// Dialog size configuration for consistent UX across FluentUI dialogs
export const dialogSizes = {
  small: {
    maxWidth: '600px',
    maxHeight: '60vh',
  },
  
  medium: {
    maxWidth: '900px',
    maxHeight: '70vh',
  },
  
  large: {
    maxWidth: '1200px',
    maxHeight: '80vh',
  },
  
  fullscreen: {
    maxWidth: '100vw',
    maxHeight: '100vh',
  }
} as const;

export type DialogSize = keyof typeof dialogSizes;
